<checkbox name="disabledCheckbox" value="1" [(ngModel)]="flexCheckDisabled" disabled>Disabled checkbox</checkbox>
<checkbox name="disabledCheckbox" value="2" [(ngModel)]="flexCheckDisabled" disabled>Disabled checked checkbox</checkbox>
